import Link from 'next/link';
import { FAQPageJsonLd, NextSeo } from 'next-seo';

import Footer from '@/components/layouts/Footer';
import Header from '@/components/layouts/Header';
import { homepageFaqs } from '@/content/chatCoFaqs';
import { productFacts } from '@/content/productFacts';

export default function FaqsPage() {
  return (
    <>
      <NextSeo
        title="Frequently Asked Questions"
        description="Answers about Chat.co knowledge agents, source citations, deployment, data protection, and the 14-day trial."
        canonical="https://chat.co/faqs"
      />
      <FAQPageJsonLd
        mainEntity={homepageFaqs.map((faq) => ({
          questionName: faq.question,
          acceptedAnswerText: faq.answer,
        }))}
      />
      <Header />
      <main className="mx-auto max-w-3xl px-6 py-20">
        <h1 className="text-4xl font-bold">Chat.co frequently asked questions</h1>
        {homepageFaqs.map((faq) => (
          <section key={faq.id} id={faq.id} className="mt-8">
            <h2 className="text-xl font-semibold">{faq.question}</h2>
            <p className="mt-3 leading-relaxed text-slate-600">{faq.answer}</p>
          </section>
        ))}
        <p className="mt-10">
          <Link href={productFacts.pricingUrl} className="text-primary-600 underline">
            Current pricing
          </Link>{' '}
          ·{' '}
          <Link href="/product" className="text-primary-600 underline">
            Product facts
          </Link>{' '}
          ·{' '}
          <Link href="/docs" className="text-primary-600 underline">
            Documentation
          </Link>
        </p>
      </main>
      <Footer />
    </>
  );
}
